module.exports = __webpack_public_path__ + "media/hph-24-08_faculty-achievements.1599e35b.mp4";